import axios from "../../../config/axiosConfig";

// El backend devuelve { rows, total } — extraemos solo las filas
// para que los consumidores sigan recibiendo un array directo en resp.data
const extractRows = (response) => {
  const d = response.data;
  if (Array.isArray(d)) return response;          // ya es array (compatibilidad)
  if (d?.rows) response.data = d.rows;            // nuevo formato paginado
  return response;
};

export const getChipsInactivos = ({ ciudad, buscar = "" }) =>
  axios
    .get("/api/equipos-chip", {
      params: {
        estado: "Inactivo",
        // ciudad: ciudad || undefined,  // descomentar si se filtra por sucursal
        ...(buscar ? { buscar } : {}),
      },
    })
    .then(extractRows);